import type { ServicePartType } from '../../types';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = (): {
    NO_PARTS_FOUND: string;
    PART_TYPES: Record<ServicePartType, string>;
    SEARCH: string;
} => {
    const t = useTranslate('partSelectPanelField');

    return {
        NO_PARTS_FOUND: t('noPartsFound'),
        PART_TYPES: {
            BATTERY: t('battery'),
            FLOW_METER: t('flowMeter'),
            MOTOR: t('motor'),
            PROPELLER_SET: t('propellerSet'),
            PUMP: t('pump')
        },
        SEARCH: t('search')
    };
};

export default useTranslation;
